import { useNavigate } from 'react-router-dom';
import { Button, Text } from '@ebh/capsule';
import styles from './styles';

interface ErrorPageProps {
  onRetry?: () => void;
}

const ErrorPage = ({ onRetry }: ErrorPageProps) => {
  const navigate = useNavigate();
  return (
    <div css={styles.container} data-testid="P5qR8sT1uV4wX7yZ0aB-">
      <Text variant="header-4" data-testid="C3dE6fG9hI2jK5lM8nO-">
        Oops! Something went wrong
      </Text>
      <Text
        variant="sub-heading-1"
        color="gray-500"
        data-testid="P9qR2sT5uV8wX1yZ4aB-"
      >
        An Unexpected Error Occurred. Please try again or contact support if the
        problem presists.
      </Text>
      <div css={styles.buttonWrapper} data-testid="C7dE0fG3hI6jK9lM2nO-">
        {onRetry ? (
          <Button
            variant="secondary"
            onClick={onRetry}
            css={[{ cursor: 'pointer' }]}
          >
            Try Again
          </Button>
        ) : (
          <Button
            variant="secondary"
            onClick={() => navigate(-1)}
            data-testid="P1qR4sT7uV0wX3yZ6aB-"
            css={[{ cursor: 'pointer' }]}
          >
            Go Back
          </Button>
        )}

        <Button
          variant="primary"
          onClick={() => navigate('/')}
          data-testid="C5dE8fG1hI4jK7lM0nO-"
          css={[{ cursor: 'pointer' }]}
        >
          Go to Home
        </Button>
      </div>
    </div>
  );
};

export default ErrorPage;